import Icon from "@/components/Icon";
import { useHideBack } from "@/hooks/useHideBack";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

/**
 * mobile header, page title
 * @param title page title
 * @param back route back
 * @param onBack route back callback
 * @param right right dom
 * @param fixed fixed or sticky style
 * @param transparent bg transparent
 */
const MobilePageHeader = ({
  title,
  back = false,
  onBack,
  right,
  fixed = false,
  transparent = false,
}: {
  title?: string;
  back?: boolean;
  onBack?: () => void;
  right?: React.ReactNode;
  fixed?: boolean;
  transparent?: boolean;
}) => {
  const { t } = useTranslation();
  const router = useRouter();
  // App 内嵌场景：hideBack=true 时整个头部（返回按钮/标题/高度）一并隐藏
  const hideBack = useHideBack();

  // handle router back
  const handleBack = () => {
    if (!onBack) {
      router.back();
    } else {
      onBack();
    }
  };

  // App 内嵌：整条头部不渲染，连高度一起去掉
  if (hideBack) return null;

  return (
    <header
      className={`${fixed ? "fixed" : "sticky"} ${
        transparent ? "bg-transparent" : "bg-white"
      } top-0 z-40 flex h-14 w-full items-center justify-between  px-mobile lg:hidden`}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {back && (
        <div
          className="absolute left-0 top-0 flex h-full items-center px-mobile"
          onClick={handleBack}
        >
          <Icon name="arrow-back" isMobile size={20} />
        </div>
      )}
      <div className="flex flex-1 justify-center text-base font-semibold text-stone-800">
        {title ? t(`${title}`) : ""}
      </div>
      {right}
    </header>
  );
};

export default MobilePageHeader;
